webpackJsonp([35783957827783],{

/***/ 283:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrap":"src-components-Info----Info-module---wrap---1z7sU","xGrid":"src-components-Info----Info-module---xGrid---2mJY7","xCol":"src-components-Info----Info-module---xCol---1yVuq","yGrid":"src-components-Info----Info-module---yGrid---2kDlO","yCol":"src-components-Info----Info-module---yCol---1715S","claim":"src-components-Info----Info-module---claim---8gpyC","bio":"src-components-Info----Info-module---bio---3CMzd","services":"src-components-Info----Info-module---services---1KIrv","mail":"src-components-Info----Info-module---mail---1Aab9","office":"src-components-Info----Info-module---office---1GWaJ","footer":"src-components-Info----Info-module---footer---2YK0z"};

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	module.exports = {"claim":"Front-end development","subclaim":"& design","mail":{"text":"hello@nik-sytnik.com","link":"mailto:hello@nik-sytnik.com"},"bio":"<p>I am a multidisciplinary front-end developer building high quality, polished user interfaces through the mediums of <span>visual design</span> and <span>front-end development</span>.</p><p>I have over seven years of industry experience and a broad skill-set that encompasses the following areas:</p>","services":["Content strategy","Creative direction","Prototyping","Visual design","Front-end development","Analytics & SEO"],"office":"Working at Aizon","footer":"Barcelona"}

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(283);
	
	var _data = __webpack_require__(323);
	
	var _data2 = _interopRequireDefault(_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Info = function Info(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'src-components-Info----Info-module---wrap---1z7sU' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'src-components-Info----Info-module---claim---8gpyC' },
	      _data2.default.claim,
	      _react2.default.createElement(
	        'span',
	        null,
	        _data2.default.subclaim
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: 'src-components-Info----Info-module---mail---1Aab9', href: _data2.default.mail.link },
	      _data2.default.mail.text
	    )
	  );
	};
	
	exports.default = Info;
	module.exports = exports['default'];

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrap":"src-components-Showcase----Showcase-module---wrap---iVMqY","title":"src-components-Showcase----Showcase-module---title----HiMZ","media":"src-components-Showcase----Showcase-module---media---1sG3f"};

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import placeholder from './placeholder.jpg'
	
	var Showcase = function (_Component) {
	  _inherits(Showcase, _Component);
	
	  function Showcase() {
	    _classCallCheck(this, Showcase);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Showcase.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'src-components-Showcase----Showcase-module---wrap---iVMqY' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'src-components-Showcase----Showcase-module---title----HiMZ' },
	        'Nik Sytnik',
	        _react2.default.createElement(
	          'span',
	          null,
	          '(b. 1990 UKR)'
	        )
	      )
	    );
	  };
	
	  return Showcase;
	}(_react.Component);
	
	exports.default = Showcase;
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Showcase = __webpack_require__(198);
	
	var _Showcase2 = _interopRequireDefault(_Showcase);
	
	var _Info = __webpack_require__(197);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Showcase2.default, null),
	    _react2.default.createElement(_Info2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-0579ca1ce745407b3d83.js